import { fromJS, List, Record } from '@gonfalon/immutable-shim/immutableShim';

import { createHunk } from '../createHunk';

import { type HunkRecord } from './HunkRecord';

type ReferenceType = {
  path: string;
  hint: string;
  hunks: List<HunkRecord>;
};

export class Reference extends Record<ReferenceType>({
  path: '',
  hint: '',
  hunks: List(),
}) {}

export function createReference(props = {}) {
  const reference = props instanceof Reference ? props : new Reference(fromJS(props));
  return reference.update('hunks', (hs) => hs && hs.map(createHunk));
}
